export const v = {
	headerHeight: "5rem",
	smallDist: "1rem",
	mediumDist: "2rem",
	largeDist: "3rem",
	xLargeDist: "4rem",
	xxLargeDist: "5rem",
};

export const b = {
	medium: `(min-width: 600px)`,
	large: `(min-width: 1200px)`,
};

export const t = {
	fastSp: `all 0.3s ease`,
	midSp: `all 0.5s ease`,
	lowSp: `all 1s ease`,
};

export const color = {
	blue: "#252941",
	lightBlue: "#6287f8",
	oceanBlue: "#73fffe",
	yellow: "#fbf665",
	orange: "#ff6e27",
};
